import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { format } from 'date-fns';
import { BehaviorSubject } from 'rxjs';
import { dbDayDateToken } from 'server/static/dbDayDateToken';
import { EmploymentAvailabilityManagementService } from '../service/employment-availability-management.service';

@Component({
  selector: 'app-temp-work-availability-management-filter',
  templateUrl: './employment-availability-management-filter.component.html',
  styleUrls: ['./employment-availability-management-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmploymentAvailabilityManagementFilterComponent {
  preparedFromDate$ = new BehaviorSubject<string | undefined>(undefined);

  constructor(
    private router: Router,
    public managementService: EmploymentAvailabilityManagementService,
  ) {}

  prepareFromDate(fromDate: Date) {
    this.preparedFromDate$.next(format(fromDate, dbDayDateToken));
  }

  // the to-date triggers a change when the from-date is changed
  updateToParam(to: Date) {
    const preparedFromDate = this.preparedFromDate$.value;
    if (!preparedFromDate || !to) {
      return;
    }
    this.updateQueryParams({
      selectedFrom: preparedFromDate,
      selectedTo: to ? format(to, dbDayDateToken) : null,
    });
  }

  updateQueryParams(queryParams: { [key: string]: string | null }) {
    this.router
      .navigate([], {
        queryParamsHandling: 'merge',
        queryParams,
      })
      .then();
  }

  clearDates() {
    this.updateQueryParams({
      selectedFrom: null,
      selectedTo: null,
    });
  }
}
